import React, { useState } from 'react';
import * as NoteUI from '../NoteUI';
import { IconWrapper, SvgIcon } from '../../../../Icon';
import { globalFormat } from '../../../../../utils/formatting';
import useBrowserTimezoneLabel from '../../../../../utils/hooks/useBrowserTimezoneLabel';
import NoteActions from '../NoteActions';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../../../../../path';
import {
  DraggableAttributes,
  DraggableSyntheticListeners,
} from '@dnd-kit/core';
import { IDashboardNoteFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';

interface IDashboardNoteProps {
  noteId: string;
  content: IDashboardNoteFieldsFragment;
  dragHandleProps?: {
    attributes: DraggableAttributes;
    listeners?: DraggableSyntheticListeners;
  };
}

const DashboardNote = ({
  noteId,
  content,
  dragHandleProps,
}: IDashboardNoteProps) => {
  const { dateFormat, timeFormat } = globalFormat.getGlobalFormat();
  const browserTimeZoneLabel = useBrowserTimezoneLabel();
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (content.dashboard.isDeleted) {
      return;
    }
    navigate(appRoutes.dashboard.generateLink(content.dashboard.baseId));
  };

  return (
    <NoteUI.Container>
      <NoteUI.Header
        onMouseOver={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <NoteUI.Row>
          <IconWrapper size={16}>
            {isHovered && dragHandleProps && (
              <NoteUI.DragHandle
                name="drag-drop"
                width={12}
                height={12}
                {...dragHandleProps.attributes}
                {...dragHandleProps.listeners}
              />
            )}
            {!isHovered && <SvgIcon name="dashboard" width={16} height={16} />}
          </IconWrapper>
          <NoteUI.Name
            onClick={handleClick}
            $isDisabled={content.dashboard.isDeleted}
          >
            Dashboard
            {content.dashboard.isDeleted && <div>(Deleted)</div>}
          </NoteUI.Name>
        </NoteUI.Row>
        <NoteActions noteId={noteId} />
      </NoteUI.Header>
      <NoteUI.Content>
        <NoteUI.Title>{content.dashboard.name}</NoteUI.Title>
        <NoteUI.Description>{content.dashboard.description}</NoteUI.Description>
        <NoteUI.RefreshDate>
          Refreshed on{' '}
          {globalFormat.formatDate(content.dashboard.refreshedAt, {
            dateFormat,
            timeFormat,
          })}{' '}
          {browserTimeZoneLabel}
        </NoteUI.RefreshDate>
      </NoteUI.Content>
    </NoteUI.Container>
  );
};

export default DashboardNote;
